import { render, staticRenderFns } from "./ApplicationCreateDetails.vue?vue&type=template&id=2f596fa5&"
import script from "./ApplicationCreateDetails.vue?vue&type=script&lang=js&"
export * from "./ApplicationCreateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports